import React, { useState, useEffect } from "react";
import "./App.css";
import "./About.css";
import Preloader from "./Preloader";
import { Firebase } from "./firebase/FirebaseConfig.js";
import Aos from "aos";
import "aos/dist/aos.css";
import Header from './Header1';
function About() {
  const [about, setAbout] = useState("");

  useEffect(() => {
    Aos.init({ duration: 2000 });

    Firebase.firestore()
      .collection("About")
      .get()
      .then((snapshot) => {
        snapshot.forEach((ele) => {
          setAbout(ele.data());
        });
      });
  });


  return (
    <div className="main-sec">
      {!about ? (
        <>
          <div className="preloader">
            <Preloader />
          </div>
        </>
      ) : (
          <>
        
          <Header/>
          <main className='main-sec-1'>
          <setion>
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-12">
                  <h1 className="about-title" data-aos="fade-up">
                    LIBIN LUVIS
                  </h1>
                </div>

                <div className="col-md-12 col-12">
                  <div className="about-intro">
                    <h data-aos="fade-up">{about.intro}</h>
                  </div>
                </div>
              </div>
            </div>
          </setion>
          <section className="skills">
            <div className="container">
              <div className="row">
                <div className="col-md-6  col-12">
                  <h className="skill-title">Tools & Techs</h>
                </div>
                <div className="col-md-6  col-12">
                  <div className="skill-table" data-aos="fade-up">
                    <div>Python</div>
                    <div>C</div>
                    <div>JavaScript</div>
                    <div>C++</div>
                    <div>django</div>
                    <div>Full Stack Dev</div>
                    <div>HTML5</div>
                    <div>CSS</div>
                    <div>Bootstrap</div>
                    <div>Node.js</div>
                    <div>React.js</div>
                    <div>Turbo C++</div>
                    <div>git github</div>
                    <div>Figma</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          </main>
          <section className="fotter-box">
            <div className="container">
              <div className="fotter">
                <h1>Let's Work together</h1>
                <div className="email-box">
                  <a className="email-text" href='mailto:libinluvis10@gmail.com'>Write an Email</a>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-12">
                  <p className="ftext">
                  <hr></hr>
                   Portfolio 2021 Designed and developed by Libin Luvis
                  </p>
                </div>
              </div>
            </div>
          </section>
        </>
        
      )}
    </div>
  );
}

export default About;
